/**
 * The posts list's search parameters — `?phase=` and `?q=` — on their own, so the two
 * route files can declare them without importing the page.
 *
 * A route's `validateSearch` stays in the main chunk when its component is split off
 * (`vite.config.ts` `autoCodeSplitting`), and it would take the whole module it is
 * imported from with it: declared beside `PostsPage`, the page and everything it imports
 * shipped with the shell. Here it costs the schema and nothing else.
 */

import { BlogPostPhaseSchema } from '@fareast/shared'
import { z } from 'zod'

import { routeSearch } from '../../search/useSearchState.js'

/** The list's two search parameters. Both optional: none is "every post". */
export const PostsSearchSchema = z.object({
  phase: BlogPostPhaseSchema.optional(),
  q: z.string().trim().min(1).max(100).optional(),
})

/** The route's `validateSearch`, so the router keeps both across a navigation. */
export const parsePostsSearch = routeSearch(PostsSearchSchema)
